<template>
  <div>
    <b-alert variant="danger"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>

      <b-card>
        <div slot="header">
          Error Logs
        </div>
        <!-- User Interface controls -->
        <b-row>
          <b-col md="6" class="my-0">
            <b-form-group class="my-1">
              <b-input-group v-on:keyup.enter="LoadData" v-on:keyup.escape="ClearSearch">
                <!--v-on:keyup.esc="ClearSearch"-->
                <b-form-input @keydown.native="EscClearSearch" v-model="tbxFilter" id="tbxFilter" placeholder="Type to search by Error Code, Dealership Id or error message" />
                <b-input-group-append>
                  <b-btn class="btn btn-default text-white ml-2" @click="ClearSearch">
                    <i class="fa fa-eraser" title="Clear Search"></i> <strong class="text-white">Clear</strong>
                  </b-btn>
                  <b-btn class="btn btn-warning text-white ml-2" @click="LoadData">
                    <i class="fa fa-search" title="Search"></i> <strong class="text-white">Search</strong>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col md="6" class="my-1"><div class="mr-2" style="text-align:right">Showing {{ GetRowCount() }} / {{ totalCount }} records</div></b-col>
        </b-row>
        <!-- Main table element -->
        <b-table id="tblMain" :items="FilteredRecords" hover striped bordered small :fields="fields" :current-page="currentPage" :per-page="perPage" :sort-compare="onSortChanged" show-empty>
          <template slot="ERROR_LOG_ID" slot-scope="row">
            {{row.value}}
          </template>
          <template slot="CREATED_TS" slot-scope="row">
            {{row.value | formatDate}}
          </template>
          <template slot="created_to_now" slot-scope="row">
            {{row.item.CREATED_TS | formatDateToNow}}
          </template>
          <template slot="show_details" slot-scope="row">
            <b-row class="px-2">
              <b-col md="12">
                <b-button @click.stop="row.toggleDetails" class="btn btn-info text-white btn-sm">
                  <i class="fa fa-info-circle"></i> <strong class="text-white">{{ row.detailsShowing ? 'Hide' : 'Show'}} Details</strong>
                </b-button>
              </b-col>
            </b-row>
          </template>
          <template slot="row-details" slot-scope="row">
            <b-card>
              <b-row>
                <b-col>
                  <strong>Message:</strong>
                  <br />
                  <div class="hljs wordwrap" v-html="Prettify(row.item.MESSAGE)"></div>
                  <!--<highlight-code lang="sql">{{row.item.MESSAGE}}</highlight-code>-->
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col>
                  <strong>Stack Trace:</strong>
                  <br />
                  <div class="hljs wordwrap" v-html="Prettify(row.item.STACK_TRACE)"></div>
                  <!--<highlight-code lang="csharp">{{row.item.STACK_TRACE}}</highlight-code>-->
                </b-col>
              </b-row>
              <br />
              <b-row v-if="row.item.EXTRA_INFO !== undefined && row.item.EXTRA_INFO.length>0">
                <b-col md="12">
                  <strong>Extra Info:</strong>
                  <br />
                  <div class="hljs wordwrap" v-html="Prettify(row.item.EXTRA_INFO)"></div>
                  <!--<highlight-code lang="csharp" inline>{{row.item.EXTRA_INFO}}</highlight-code>-->
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col md="10">

                </b-col>
                <b-col md="2">
                  <b-button class="btn btn-info text-white btn-sm" @click="row.toggleDetails">Hide Details</b-button>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-table>
        <!-- NAV -->
        <nav>
          <b-pagination :total-rows="GetRowCount(Items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
        </nav>
      </b-card>
    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import moment from 'moment'
import { setTimeout } from 'timers'
import HL from 'highlight.js'

export default {
  components: {
    loading
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      txtLoading: 'Loading...',
      boolLoading: false,
      tbxFilter: undefined,
      intervalHandle: undefined,
      gettingData: false,
      gettingDataInterval: 5000,
      totalCount: 0,
      Items: [],
      itemsObject: {},
      fields: [
        { key: 'ERROR_LOG_ID', label: 'Error Code', sortable: true },
        { key: 'CREATED_TS', label: 'Date', sortable: true },
        { key: 'DEALERSHIP_ID', label: 'Dealership Id', sortable: true },
        { key: 'ACCOUNT_NUMBER', label: 'Account number', sortable: true },
        { key: 'APPLICATION', label: 'App', sortable: true },
        { key: 'CLASS', label: 'CLASS', sortable: true },
        { key: 'created_to_now', label: '', sortable: false },
        { key: 'show_details', label: '', sortable: false }
      ],
      currentPage: 1,
      perPage: 15,
      onSortChanged (a, b, key) {
        if (['accountLastRun', 'EXPIRATION_DATE'].indexOf(key) !== -1) {
          var a1
          var b1
          switch (key) {
            // case 'FUTUREUNKNOW':
            //  console.log(`${JSON.stringify(new Date())} (typeof a) ${(typeof a[key])} [${JSON.stringify(a[key])}] (typeof a) ${(typeof a[key])} [${JSON.stringify(a[key])}]`);
            //  break;
            case 'CREATED_TS':
            case 'accountLastRun':
              a1 = moment(a[key])
              b1 = moment(b[key])

              if (a1.isValid() && b1.isValid()) {
                if (a1.isSame(b1)) {
                  return 0
                }
                if (a1.isAfter(b1)) {
                  return 1
                }
                return -1
              } else {
                if (a1.isValid()) {
                  return 1
                }
                if (b1.isValid()) {
                  return -1
                }
              }
              return 0
          }
        } else {
          if (typeof a[key] === 'number' && typeof b[key] === 'number') {
            // If both compared fields are native numbers
            return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
          } else if (typeof a[key] === 'boolean' && typeof b[key] === 'boolean') {
            a1 = ((a[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            b1 = ((b[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            return a1 < b1 ? 1 : (a1 > b1 ? -1 : 0)
          } else {
            a1 = (a[key] + '')
            b1 = (b[key] + '')
            return (a1).localeCompare(b1)
          }
        }
      }
    }
  },
  created () {
    let self = this
    self.LoadData(true)
  },
  methods: {
    LoadData (onCreated) {
      let self = this

      if (self.gettingData === false) {
        if (onCreated !== true) {
          self.boolLoading = true
        }

        self.gettingData = true

        let obj = {
          q: self.tbxFilter
        }

        let axiosConfig = {
          timeout: 60000
        }

        axios.post('/api/Internal/LoadErrorLog', obj, axiosConfig)
          .then(response => {
            self.errMsg = ''
            self.showDismissibleAlert = false

            self.totalCount = response.data.length
            self.Items = response.data
          })
          .catch(error => {
            if (error !== undefined && error.response !== undefined && error.response.status === 403) {
              self.$router.push('/login')
            }
            self.errMsg = 'There was an error getting data : ' + ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
            self.showDismissibleAlert = true
          }).then(response => {
            self.gettingData = false
            self.boolLoading = false
          })
      }
    },
    GetRowCount () {
      let self = this
      return self.FilteredRecords.length
    },
    ClearSearch () {
      let self = this
      self.tbxFilter = undefined
      self.LoadData()
    },
    EscClearSearch (event) {
      let self = this
      if (event.key === 'Escape') {
        self.ClearSearch()
      }
    },
    UNescapeHtml (str) {
      str = str.replace(/&amp;/g, '&')
      str = str.replace(/&lt;/g, '<')
      str = str.replace(/&gt;/g, '>')
      str = str.replace(/&quot;/g, '"')
      str = str.replace(/&#39;/g, "'")
      str = str.replace(/&#x2F;/g, '/')
      str = str.replace(/&#x60;/g, '`')
      str = str.replace(/&#x3D;/g, '=')
      str = str.replace(/&nbsp;/g, ' ')

      return str
    },
    escapeHtml (string) {
      var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
      }
      return String(string).replace(/[&<>"'`=\/]/g, function (s) {
        return entityMap[s]
      })
    },
    NewLiner (str) {
      if (str === undefined || str === null) {
        return ''
      }
      str = str.replace(/\r\n/g, '<br>')
      return str
    },
    SpaceRemover (str) {
      if (str === undefined || str === null) {
        return ''
      }
      str = str.replace(/ {8}/g, '&nbsp;')
      str = str.replace(/ {7}/g, '&nbsp;')
      str = str.replace(/ {6}/g, '&nbsp;')
      str = str.replace(/ {5}/g, '&nbsp;')
      str = str.replace(/ {4}/g, '&nbsp;')
      str = str.replace(/ {3}/g, '&nbsp;')
      str = str.replace(/ {2}/g, '&nbsp;')
      str = str.replace(/ /g, '&nbsp;')
      // str = str.replace(/:{/g, ':&lt;br&gt;{')
      // str = str.replace(/},/g, '},&lt;br&gt;')
      return str
    },
    Prettify (str) {
      if (str === undefined || str === null) {
        return ''
      }
      let self = this

      str = self.SpaceRemover(str)
      str = self.UNescapeHtml(str)

      let hlObject = HL.highlightAuto(str, ['cs', 'swift', 'csharp', 'xml', 'json', 'cmd'])

      str = hlObject.value
      return str
    }
  },
  filters: {
    formatDate: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY hh:mm:ss a')
      }
      return ''
    },
    formatDateToNow: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        let localTime = m.add(moment().utcOffset(), 'm')
        return localTime.toNow(true) + ' ago'
      }
      return ''
    }
  },
  computed: {
    FilteredRecords: function () {
      let self = this

      if (self.boolLoading) {
        return []
      } else {
        // if (self.tbxFilter !== undefined && self.tbxFilter !== null && self.tbxFilter.length > 0) {
        //  return self.Items.filter(u => (u.account + '').toLowerCase().includes(self.tbxFilter.toLowerCase()) ||
        //      (u.accountName + '').toLowerCase().includes(self.tbxFilter.toLowerCase()))
        // } else {
        return self.Items
        // }
      }
    }
  },
  mounted () {
    let self = this

    self.boolLoading = true
  }
}
</script>

<style type="text/css">
  .hljs {
    background: transparent;
  }
  .wordwrap {
    font-size: 87.5%;
    white-space: pre-wrap; /* CSS3 */
    white-space: -moz-pre-wrap; /* Firefox */
    white-space: -pre-wrap; /* Opera <7 */
    white-space: -o-pre-wrap; /* Opera 7 */
    word-wrap: break-word; /* IE */
  }
</style>



// WEBPACK FOOTER //
// src/views/ErrorLogs.vue